import { agencyBasic } from '@app/models';
import { gql } from 'apollo-angular';

const dependentAgencyParameter = gql`
  fragment dependentAgencyParameter on DependentAgencyParameter {
    values
    agencyParameter {
      id
      parameterName
      trainTypeNestedCondition {
        id
        description
      }
    }
  }
`;

export const baseAgencyParameter = gql`
  fragment baseAgencyParameter on AgencyParameter {
    id
    parameterName
    ttpId
    agency {
      ...agencyBasic
    }
    dossierLevel
    hidden
    mandatory
    commonMandatoryParameterDependency
    description
    typeInfo {
      type {
        id
        description
      }
      minLength
      maxLength
      values
      defaultValue
      format
    }
  }
  ${agencyBasic}
`;

export const agencyParameter = gql`
  fragment agencyParameter on AgencyParameter {
    ...baseAgencyParameter
    nestedCondition {
      ...dependentAgencyParameter
    }
    mandatoryException {
      ...dependentAgencyParameter
    }
    trainTypeNestedCondition {
      id
      description
    }
  }
  ${dependentAgencyParameter}
  ${baseAgencyParameter}
`;
